export default "__VITE_ASSET__bc59bfbe__"